import vv_utils from './vv_utils';
import { threeStepInvokeMachine } from "./vv_api";
/* Register New
const req = {
  'name' : name,
  'email': email,
  'agreements': terms
}
*/
/* Login New
const req = {
  'provider': submitter.value,
  'email': email
}
*/
async function requestWebAuthn(req, type, alertbox) {

  let support = await vv_utils.detectWebAuthnSupport();
  if(support==='not supported') {
    throw new vv_utils.ShowableException("WebAuthn is not supported in this browser.");
  }

  const { interpret } = window.XState;

  let beginURL = `/v1/auth/webauthn/signup/begin`;
  let finishURL = `/v1/auth/webauthn/signup/finish`;
  if (JSON.stringify(req) === '{}' && type === "register") {
    beginURL = "/v1/settings/webauthn/begin";
    finishURL = "/v1/settings/webauthn/finish";
  } else if (type === "login") {
    beginURL = "/v1/auth/webauthn/login/begin";
    finishURL = "/v1/auth/webauthn/login/finish";
  }

  function beginWebAuthn(context, event) {
    return new Promise((resolve, reject) => {
      try {
        resolve(vv_utils.vv_fetch_state(beginURL, req));
      } catch (error) {
        reject(error);
      }
    });
  }

  function requestNavigatorCreds(context, event) {
    return new Promise((resolve, reject) => {
      try {
        
        let beginRes = Object.assign({}, context.first_data);
        beginRes.options.challenge = vv_utils.b64Decode(beginRes.options.challenge);
        if (type === "register") {
          beginRes.options.user.id = vv_utils.b64Decode(beginRes.options.user.id);
          if (navigator.userAgent.toLowerCase().includes("android")) {
            beginRes.options.authenticatorSelection.requireResidentKey = false;
            beginRes.options.authenticatorSelection.userVerification = "discouraged";
            //delete beginRes.options.authenticatorSelection.userVerification;
          }
          
          resolve(
            navigator.credentials.create({
              publicKey: beginRes.options
            })
          );
        } else {
          beginRes.options.allowCredentials.forEach(function (v) {
            //eslint-disable-next-line no-param-reassign
            v.id = vv_utils.b64Decode(v.id);
          });
          if (navigator.userAgent.toLowerCase().includes("android")) {
            beginRes.options.userVerification = "discouraged";
          }
          
          resolve(
            navigator.credentials.get({
              publicKey: beginRes.options
            })
          );
        }

      } catch (error) {
        reject(error);
      }
    });
  }


  /* eslint-disable max-len */
  function finishWebAuthn(context, event) {
    return new Promise((resolve, reject) => {
      try {
        
        const credential = context.second_data;
        var clientDataStr = vv_utils.bufToStr(credential.response.clientDataJSON);
        var clientDataObj = JSON.parse(clientDataStr);

        
        

        const finishReq = {
          token: context.first_data.token,
          credential: {
            type: credential.type,
            id: credential.id,
            rawId: vv_utils.b64Encode(new Uint8Array(credential.rawId)),
            response: {
              clientDataJSON: vv_utils.b64Encode(
                new Uint8Array(credential.response.clientDataJSON)),
            },
          },
        }
        if (type === "login") {
          finishReq.email = req.email;
          finishReq.credential.response.authenticatorData = vv_utils.b64Encode(credential.response.authenticatorData);
          finishReq.credential.response.signature = vv_utils.b64Encode(new Uint8Array(credential.response.signature));
          finishReq.credential.response.userHandle = vv_utils.b64Encode(new Uint8Array(credential.response.userHandle));
        } else {
          finishReq.credential.response.attestationObject = vv_utils.b64Encode(new Uint8Array(credential.response.attestationObject));
        }
        
        resolve(vv_utils.vv_fetch_state(finishURL, finishReq));
      } catch (error) {
        reject(error);
      }
    });

  }
  /* eslint-enable max-len */

  return new Promise((resolve, reject) => {
    /* eslint-disable max-len */
    const passkeyService = interpret(
      threeStepInvokeMachine.withConfig({
        actions: {
          actionFailed: (context, event) => {
            
            vv_utils.logError(context.error);
            vv_utils.showStateErrors("There was an unexpected error", context.error, alertbox);
            reject(context.error);
          },
          actionSucceeded: (context, event) => {
            resolve(context.third_data);
          }
        },
        services: {
          first_action_service: (context, event) => beginWebAuthn(context, event),
          second_action_service: (context, event) => requestNavigatorCreds(context, event),
          third_action_service: (context, event) => finishWebAuthn(context, event),
        }
      })
    )
      .onTransition((state) => {  })
      .start();
    /* eslint-enable max-len */

    passkeyService.send("FIRST", req);
  });


}